export default __webpack_public_path__ + "2d5198822ab091ce430554a436cdf53c.woff2";